import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { INegotiationLoggable } from '@services/strategy-pattern-login/iNegotiation-loggable';
import { HttpService } from '@services/http-service';
import { ConfigService } from '@services/webFeeder/config.service';
import { Observable, BehaviorSubject , of } from 'rxjs';
import { HistoryFilterOrder } from '@model/webFeeder/history-filter-order';
import { Constants } from '@utils/constants';
import { AppUtils } from '@utils/app.utils';
import { DatePipe } from '@angular/common';
import { MarketEnum } from '@model/enum/market.enum';
import { SideEnum } from '@model/enum/side.enum';
import { TypeOrderEnum } from '@model/enum/type-order.enum';
import { HistoryOrder } from '@model/webFeeder/history-order.model';
import { HttpClient } from '@angular/common/http';
import { MessageCancelTrade } from '@model/webFeeder/message-trade-order-cancel';
import { MessageTrade } from '@model/webFeeder/message-trade-order';
import { CustodyEarningsFilterType } from '@model/enum/custody-model.enum';
import { MarketTypeEnum } from '@model/enum/market-type.enum';
import { CloseInvertEnum } from '@model/enum/close-invert.enum';
import { LiquidationTypeEnum } from '@model/enum/liquidation-type.enum';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class INegotiationWso2Service implements INegotiationLoggable {

  private _quantityOpenOrder = new BehaviorSubject<number>(0);
  quantityOpenOrder$ = this._quantityOpenOrder.asObservable();
  public _strategiesList = [];
  public _brokerAccountList = [];
  public marketTypeEnum = MarketTypeEnum;

  constructor(
    private _httpService: HttpService,
    private _configService: ConfigService,
    private datePipe: DatePipe,
    private httpClient: HttpClient,
    private _datePipe: DatePipe
  ) { }

  setQuantityOpenOrder(qtd: number) {
    this._quantityOpenOrder.next(qtd);
  }

  brokerServiceAccountList(account: string): any {
    let urlContext = '';
    let path = '';
    if (this._brokerAccountList.length === 0 || !this._brokerAccountList || account) {
      if (this._configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginW) {
        if (this._configService.isUserAssessorLogged()) {
          let pathUrl = '/services/negotiation/brokerServiceFullAccountListInformation?&financial=true&simplified=true';
          pathUrl = account ? pathUrl + '&account=' + account.toString() : pathUrl;
          return this._httpService.doGet(this._configService.getApiUrlBusenessWSO2() + pathUrl)
            .pipe(map((response: any) => {
              if (response) {
                this._brokerAccountList = !account ? response : this._brokerAccountList;
                return response;
              }
              return [];
            }));
        } else {
          if (!account) {
            return of([]);
          }
          if (environment.SUITABILITY_OMS) {
            urlContext = this._configService.getApiWebFeederRest();
            path = 'services/negotiation/brokerServiceAccountList/' + account;
          } else {
            urlContext = this._configService.getApiUrlBusenessWSO2();
            const client_id = Number(this._configService.getHbAccountId());
            path = 'facade/services/negotiation/brokerServiceAccountList/' + account + '/' + client_id;
          }
        }
      } else { // Adapter
        if (!account) {
          return of([]);
        }
        urlContext = this._configService.getApiWebFeederRest();
        path = 'services/negotiation/brokerServiceAccountList/' + account;
      }
      return this._httpService.doGet(urlContext, path)
        .pipe(map(response => {
          if (response && response.accountsBean) {
            this._brokerAccountList = response.accountsBean;
            return response.accountsBean;
          } else if (response && response.length > 0) {
            this._brokerAccountList = response;
            return response;
          }
          return [];
        }));
    } else {
      return of(this._brokerAccountList);
    }




  }

  financialAccountInformationCompl(account: string, market: string) {
    if (!account || !market) {
      return of([]);
    } else {
      return this._httpService
        .doGet(this._configService.getApiWebFeederRest(), 'services/negotiation/financialAccountInformationCompl/' + account + '/' + market)
        .pipe(map(response => {
          if (response) {
            const json = response.financialInformationBean;
            return json;
          }
          return [];
        }));
    }
  }

  positionBovespa(account: string, quote?: string) {
    let url = '';
    if (quote) {
      url = 'services/negotiation/positionBovespa/' + account + '/' + quote;
    } else {
      url = 'services/negotiation/positionBovespa/' + account;
    }
    return this._httpService
      .doGet(this._configService.getApiWebFeederRest(), url, false)
      .pipe(map(response => {
        if (response) {
          return response;
        }
        return [];
      }));
  }

  positionBmf(account: string, quote?: string) {
    let url = '';
    if (quote) {
      url = 'services/negotiation/positionBmf/' + account + '/' + quote;
    } else {
      url = 'services/negotiation/positionBmf/' + account;
    }
    return this._httpService
      .doGet(this._configService.getApiWebFeederRest(), url, false)
      .pipe(map(response => {
        if (response) {
          return response;
        }
        return [];
      }));
  }

  // WSO2
  public getHistoryOrder(
    account: string, market: string, dataInicio: string, dataFim: string, symbol: string,
    status: string, direction: string, orderID?: string, type?: string, statusGeneric?: string,
    statusGroup?: string
  ): Observable<any> {
    const params = new HistoryFilterOrder();

    params.account = account;
    params.dataInicio = dataInicio || null;
    params.dataFim = dataFim || null;
    params.orderID = orderID || null;
    params.market = '-';
    if (market === '1') {
      params.market = Constants.MARKET_BOVESPA;
    } else if (market === '2') {
      params.market = Constants.MARKET_BMF;
    }
    if (symbol && symbol !== null) {
      params.symbol = symbol.toUpperCase();
    } else {
      params.symbol = null;
    }
    if (direction && direction !== null) {
      params.direction = direction.toUpperCase();
    } else {
      params.direction = null;
    }
    if (type === '') {
      type = null;
    }
    params.type = type;
    params.statusGroup = statusGroup || null;

    if (status === 'New') {
      params.statusGroup = 'Abertas';
    } else {
      if (status && status !== null) {
        params.status = status.toUpperCase();
      } else {
        params.status = null;
      }
    }
    if (params.dataInicio !== null || params.dataFim !== null || params.orderID !== null) {
      params.queryType = '1';
    } else {
      params.queryType = '0';
    }
    if (params.dataInicio && params.dataFim) {
      params.dataInicio = this.datePipe.transform(params.dataInicio, Constants.DATE2_DDMMYYYY);
      params.dataFim = this.datePipe.transform(new Date(params.dataFim).setDate(new Date(params.dataFim).getDate() + 1),
        Constants.DATE2_DDMMYYYY);
    } else if (params.dataInicio && !params.dataFim) {
      const dataFimTEmp = params.dataInicio;
      params.dataInicio = this.datePipe.transform(params.dataInicio, Constants.DATE2_DDMMYYYY);
      params.dataFim = this.datePipe.transform(new Date(dataFimTEmp).setDate(new Date(dataFimTEmp).getDate() + 1),
        Constants.DATE2_DDMMYYYY);
    } else if (!params.dataInicio && !params.dataFim) {
      params.dataInicio = this.datePipe.transform(new Date(), Constants.DATE2_DDMMYYYY);
      params.dataFim = this.datePipe.transform(new Date().setDate(new Date().getDate() + 1), Constants.DATE2_DDMMYYYY);
    }
    return this.getParamsHistory(params);
  }

  private getParamsHistory(params: HistoryFilterOrder) {
    let urlParams = '';
    if (params && params.account && !AppUtils.isEmptyStr(params.account)) {
      urlParams += '/' + params.account;
    } else {
      urlParams += '/' + '-';
    }

    if (params && params.market && !AppUtils.isEmptyStr(params.market)) {
      urlParams += '/' + params.market;
    }

    if (params && params.dataInicio && !AppUtils.isEmptyStr(params.dataInicio) || params.dataInicio === '-') {
      urlParams += '/' + params.dataInicio;
    } else {
      urlParams += '/' + '-';
    }

    if (params && params.dataFim && !AppUtils.isEmptyStr(params.dataFim) || params.dataFim === '-') {
      urlParams += '/' + params.dataFim;
    } else {
      urlParams += '/' + '-';
    }

    if (params && params.symbol && !AppUtils.isEmptyStr(params.symbol)) {
      urlParams += '/' + params.symbol;
    } else {
      urlParams += '/' + '-';
    }

    if (params && params.status && !AppUtils.isEmptyStr(params.status)) {
      urlParams += '/' + params.status;
    } else {
      urlParams += '/' + '-';
    }

    if (params && params.direction && !AppUtils.isEmptyStr(params.direction)) {
      urlParams += '/' + params.direction;
    } else {
      urlParams += '/' + '-';
    }

    if (params && params.orderID && !AppUtils.isEmptyStr(params.orderID)) {
      urlParams += '/' + params.orderID;
    } else {
      urlParams += '/' + '-';
    }

    if (params && params.statusGroup && !AppUtils.isEmptyStr(params.statusGroup)) {
      urlParams += '/' + params.statusGroup;
    } else {
      urlParams += '/' + '-';
    }

    if (params && params.queryType && !AppUtils.isEmptyStr(params.queryType)) {
      urlParams += '/' + params.queryType;
    } else {
      urlParams += '/' + '-';
    }

    return this._httpService
      .doGet(this._configService.getApiWebFeederRest(), 'services/negotiation/historyOrder' + urlParams, false)
      .pipe(map(response => {
        if (response) {
          if (response.error) {
            return of([]);
          }
          return response;
        }
        return [];
      }));
  }


  sendOrderWso2(account: string, quote: string, fractionaryQtd: number, nonFractionaryQtd: number, price: string, market: any,
    type: TypeOrderEnum, side: SideEnum, validityOrderTemp: Date, orderStrategy: string, timeinforce?: string, orderid?: string,
    origclordid?: string, loteDefault?: number, maxfloor?: string, minqty?: string, ordertag?: string, targettrigger?: string,
    targetlimit?: string, stoptrigger?: string, stoplimit?: string, isStop?: boolean, bypasssuitability?: boolean, clordlinkid?: string,
    signature?: string
  ): Observable<any> {
    const params = new MessageTrade();
    // ------------------------------------------ SINGLE --------------------------------------------------------------
    if (validityOrderTemp && timeinforce === 'GTD') {
      const datStr = this.datePipe.transform(validityOrderTemp, 'ddMMyyyy');
      params.validityorder = datStr;
    }
    params.username = this._configService.getBrokerAccount() ? this._configService.getBrokerAccount() : account;
    if (account) {
      params.account = account;
    } else {
      return of([]);
    }

    if (price) {
      params.price = price;
    }

    if (quote) {
      params.quote = quote;
    } else {
      return of([]);
    }

    if (nonFractionaryQtd) {
      params.qtd = nonFractionaryQtd;
    }

    if (nonFractionaryQtd === 0 && fractionaryQtd > 0) {
      params.qtd = fractionaryQtd;
    }
    params.market = Number(market) && market === MarketEnum.BOVESPA ? Constants.MARKET_BOVESPA :
      Number(market) && market === MarketEnum.BMF ? Constants.MARKET_BMF : market;

    if (type) {
      params.type = type;
    } else {
      return of([]);
    }

    if (side) {
      params.side = side === SideEnum.BUY ? Constants.ORDER_SIDE_BUY : Constants.ORDER_SIDE_SELL;
    } else {
      return of([]);
    }

    if (orderStrategy) {
      params.orderStrategy = orderStrategy;
    }

    if (timeinforce) {
      params.timeinforce = timeinforce;
    } else {
      return of([]);
    }

    if (maxfloor) {
      params.maxfloor = maxfloor;
    } else {
      params.maxfloor = '0';
    }
    if (minqty) {
      params.minqty = minqty;
    }
    if (ordertag) {
      params.ordertag = ordertag;
    }

    params.loteDefault = loteDefault ? loteDefault : params.market === Constants.MARKET_BMF ? 1 : 100;

    // if (params.movingstart) {
    //   params.movingstart = null;
    // }
    // if (params.initialchangetype) {
    //   params.initialchangetype = null;
    // }
    // if (params.initialchange) {
    //   params.initialchange = null;
    // }
    // if (params.pricepercentage) {
    //   params.pricepercentage = null;
    // }
    // if (params.enteringtrader) {
    //   params.enteringtrader = null;
    // }

    if (orderid) {
      params.orderid = orderid || null;
    }

    if (origclordid) {
      params.origclordid = origclordid || null;
    }
    // ------------------------------------------ STOP ------------------------------------------------------------------
    if (isStop) {
      params.type = Constants.ORDER_TYPE_STOP;
      params.targettrigger = targettrigger || '0';
      params.targetlimit = targetlimit || '0';
      params.stoptrigger = stoptrigger || '0';
      params.stoplimit = stoplimit || '0';
    } else {
      params.targettrigger = '0';
      params.targetlimit = '0';
      params.stoptrigger = '0';
      params.stoplimit = '0';
    }

    params.bypasssuitability = bypasssuitability;
    params.clordlinkid = clordlinkid ? clordlinkid : null;
    params.contingencytype = clordlinkid ? '1' : null;
    return this.getParamsWso2(params, signature);
  }

  private getParamsWso2(params: MessageTrade, signature?: string) {
    let query = '?';

    if (params.account) {
      query += 'account=' + params.account;
    } else {
      return of([]);
    }
    if (params.orderid) {
      query += '&orderid=' + params.orderid;
    }

    if (params.origclordid) {
      query += '&origclordid=' + params.origclordid;
    }

    if (params.market) {
      query += '&market=' + params.market;
    } else {
      return of([]);
    }

    if (!(params.type === 'START') && !(params.type === 'STOP')) {
      query += '&price=' + params.price;
    }

    if (params.quote) {
      query += '&quote=' + params.quote;
    } else {
      return of([]);
    }

    if (params.qtd) {
      query += '&qtd=' + params.qtd.toString();
    } else {
      return of([]);
    }

    if (params.validityorder && params.timeinforce === 'GTD') {
      query += '&validityorder=' + params.validityorder;
    }

    if (params.targettrigger) {
      query += '&targettrigger=' + params.targettrigger.toString();
    } else {
      query += '&targettrigger=0';
    }

    if (params.targetlimit) {
      query += '&targetlimit=' + params.targetlimit.toString();
    } else {
      query += '&targetlimit=0';
    }

    if (params.stoptrigger) {
      query += '&stoptrigger=' + params.stoptrigger.toString();
    } else {
      query += '&stoptrigger=0';
    }

    if (params.stoplimit) {
      query += '&stoplimit=' + params.stoplimit.toString();
    } else {
      query += '&stoplimit=0';
    }

    if (params.type) {
      query += '&type=' + AppUtils.revertMarketType(params.type.toString());
    }

    if (params.side) {
      query += '&side=' + params.side.toString();
    } else {
      return of([]);
    }

    if (params.username) {
      query += '&username=' + params.username.toString();
    } else {
      return of([]);
    }

    if (this._configService.isUserAssessorLogged()) {
      query += '&sourceaddress=' + Constants.DEFAULT_SOURCE_ADRESS_WSO2_ASSESSOR;
    } else {
      query += '&sourceaddress=' + Constants.DEFAULT_SOURCE_ADRESS_WSO2_CLIENT;
    }

    if (params.orderStrategy) {
      query += '&orderstrategy=' + params.orderStrategy;
    }

    query += '&appname=FastTradeWeb';

    if (params.timeinforce) {
      query += '&timeinforce=' + params.timeinforce;
    } else {
      return of([]);
    }

    if (params.maxfloor && params.maxfloor !== '-' && params.maxfloor !== '0') {
      query += '&maxfloor=' + params.maxfloor;
    } else {
      query += '&maxfloor=0';
    }

    if (params.minqty) {
      query += '&minqty=' + params.minqty;
    }

    if (params.ordertag) {
      query += '&ordertag=' + params.ordertag;
    }

    if (params.bypasssuitability) {
      query += '&bypasssuitability=' + params.bypasssuitability;
    }

    if (params.clordlinkid) {
      query += '&clordlinkid=' + params.clordlinkid;
    }

    if (params.contingencytype) {
      query += '&contingencytype=' + params.contingencytype;
    }

    query += '&appName=' + Constants.DEFAULT_APP_NAME;
    return this.sendWso2(params, query, signature);
  }

  private sendWso2(params: MessageTrade, query?: any, signature?: string) {
    // const searchParams = Object.keys(params).pipe(map(key => {
    //   return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    // }).join('&');
    const eletronicSignature = this._configService.getEletronicSignatureType();
    if (eletronicSignature && eletronicSignature.isActive && eletronicSignature.type !== Constants.ELETRONIC_SIGNATURE_TYPES.string) {
      signature = null;
    }
    if (params.orderid) {
      this._configService.writeLog(query, 'SendEditOrder');
      return this._httpService
        .doPostWso2(this._configService.getApiWebFeederRest(),
          'services/negotiation/editOrder' + query, query, null, null, true, null, signature)
        .pipe(map(response => {
          if (response) {
            this._configService.writeLog(response, 'SendEditOrder > Response');
            return response;
          }
          return [];
        }));
    } else {
      this._configService.writeLog(query, 'sendNewOrderSingle');
      return this._httpService
        .doPostWso2(this._configService.getApiWebFeederRest(),
          'services/negotiation/sendNewOrderSingle' + query, query, null, null, true, null, signature)
        .pipe(map(response => {
          this._configService.writeLog(response, 'sendNewOrderSingle > Response');
          if (response) {
            return response;
          }
          return [];
        }));
    }
  }

  cancelOrderWso2(account: string, username: string, orderid: string, origclordid: string, market: string,
    quote: string, qtd: string, side: string, enteringtrader: string, signature?: string) {
    let query = '';
    const params = new MessageCancelTrade();

    if (orderid) {
      params.orderid = orderid;
      query += '?orderid=' + params.orderid;
    }
    if (origclordid) {
      params.origclordid = origclordid;
      query += '&origclordid=' + params.origclordid;
    }
    if (quote) {
      params.quote = quote;
      query += '&quote=' + params.quote;
    } else {
      return of([]);
    }
    if (side) {
      params.side = side;
      query += '&side=' + params.side;
    } else {
      return of([]);
    }
    if (qtd) {
      if (qtd.indexOf('.') !== -1) {
        qtd.replace(new RegExp('.', 'g'), '');
      }
      params.qtd = qtd;
      query += '&qtd=' + params.qtd;
    } else {
      return of([]);
    }
    if (username) {
      params.username = username;
      query += '&username=' + params.username;
    } else {
      return of([]);
    }
    if (market) {
      params.market = Number(market) === MarketEnum.BOVESPA ? Constants.MARKET_BOVESPA : Constants.MARKET_BMF;
      query += '&market=' + params.market;
    } else {
      return of([]);
    }

    if (this._configService.isUserAssessorLogged()) {
      query += '&sourceaddress=' + Constants.DEFAULT_SOURCE_ADRESS_WSO2_ASSESSOR;
    } else {
      query += '&sourceaddress=' + Constants.DEFAULT_SOURCE_ADRESS_WSO2_CLIENT;
    }

    query += '&appName=' + Constants.DEFAULT_APP_NAME;

    const eletronicSignature = this._configService.getEletronicSignatureType();
    if (eletronicSignature && eletronicSignature.isActive && eletronicSignature.type !== Constants.ELETRONIC_SIGNATURE_TYPES.string) {
      signature = null;
    }

    return this._httpService
      .doPostWso2(this._configService.getApiWebFeederRest(), 'services/negotiation/cancelOrder' + query, {}, null, null, true, true, signature)
      .pipe(map(response => {
        if (response) {
          return response;
        }
        return [];
      }));
  }

  cancelAllOrderHistoryWso2(historyOrder: HistoryOrder[]) {
    const invalidHistoryOrders: HistoryOrder[] = null; // TODO use it!
    for (let i = 0; i < historyOrder.length; i++) {
      if (!historyOrder[i].quote) {
        invalidHistoryOrders.push(historyOrder[i]);
        continue;
      }

      if (!historyOrder[i].side) {
        invalidHistoryOrders.push(historyOrder[i]);
        continue;
      } else {
        if (historyOrder[i].buyOrSell === 'C') {
          historyOrder[i].side = Constants.ORDER_SIDE_BUY;
        } else {
          historyOrder[i].side = Constants.ORDER_SIDE_SELL;
        }
      }

      // be careful, if sends fractional value separated by '.' can be generated business problem
      if (historyOrder[i].quantityRemaining) {
        if (historyOrder[i].quantityRemaining.indexOf('.') !== -1) {
          historyOrder[i].quantityRemaining.replace(new RegExp('.', 'g'), '');
        }
      } else {
        invalidHistoryOrders.push(historyOrder[i]);
        continue;
      }

      if (!historyOrder[i].username) {
        invalidHistoryOrders.push(historyOrder[i]);
        continue;
      }

      if (historyOrder[i].market) {
        historyOrder[i].market =
          Number(historyOrder[i].market) === MarketEnum.BOVESPA ? Constants.MARKET_BOVESPA : Constants.MARKET_BMF;
      } else {
        invalidHistoryOrders.push(historyOrder[i]);
        continue;
      }

      return this._httpService
        .doPostWso2(this._configService.getApiWebFeederRest(), 'services/negotiation/cancelOrder', historyOrder[i], false, null, true)
        .pipe(map(response => {
          if (response) {
            return response;
          }
          return [];
        }));
    }
  }

  // API
  sendOrderApi(account: string, quote: string, qtd: number, price: string, market: MarketEnum, type: any, side: SideEnum,
    validityOrder: Date, orderStrategy: string, timeinforce?: string, orderid?: string, origclordid?: string,
    loteDefault?: number, maxfloor?: string, minqty?: string, ordertag?: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  sendOrderStopApi(account: string, validityOrder: Date, orderStrategy: string, quote: string, qtd: number, targettrigger: string,
    targetlimit: string, stoptrigger: string, stoplimit: string, market: MarketEnum, side: SideEnum, timeinforce?: string,
    orderid?: string, origclordid?: string, loteDefault?: number, isStart?: boolean, maxfloor?: string, minqty?: string,
    orderTag?: string, bypasssuitability?: boolean, clordlinkid?: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  cancelOrderApi(account: string, username: string, orderid: string, origclordid: string, market: string,
    quote: string, qtd: string, side: string, enteringtrader: string) {
    throw new Error('Method not implemented.');
  }

  cancelAllOrderHistoryApi(historyOrder: HistoryOrder[]) {
    throw new Error('Method not implemented.');
  }

  brokeragePDF(account: string, market: string, date: Date) {
    const dateTemp = this.datePipe.transform(date, Constants.DATE2_DDMMYYYY);
    return this._httpService
      .doGetBlob(
        this._configService.getApiWebFeederRest(),
        'services/negotiation/brokeragePDF/' + account + '/' + market + '/' + dateTemp, false, 3
      )
      .pipe(map(response => {
        if (response) {
          return response;
        }
        return [];
      }));
  }

  brokerageDates(account: string, market: string, startDate: string, endDate: string) {
    if (!account || !market) {
      return of([]);
    } else {
      let url = '';
      if (this.marketTypeEnum.BOVESPA === market.toUpperCase()) {
        url = 'services/negotiation/brokerageDatesRequestBovespa/' + account + '/' + (startDate ? startDate : '-') + '/' + (endDate ? endDate : '-');
      } else {
        url = 'services/negotiation/brokerageDatesRequestBMF/' + account + '/' + (startDate ? startDate : '-') + '/' + (endDate ? endDate : '-');
      }
      return this._httpService
        .doGet(this._configService.getApiWebFeederRest(), url)
        .pipe(map(((data) => data)));
    }
  }

  statementAccount(account: string, market: string, dateStart: Date, dateEnd: Date, ipAddress: string) {
    if (!account || !market || !dateStart || !dateEnd) {
      return of([]);
    } else {
      let module = '';
      if (market === Constants.MARKET_BOVESPA) {
        module = 'statementBovespa';
      } else {
        module = 'statementBmf';
      }
      const dateStartTemp = this.datePipe.transform(dateStart, Constants.DATE2_DDMMYYYY);
      const dateEndTemp = this.datePipe.transform(dateEnd, Constants.DATE2_DDMMYYYY);
      return this._httpService
        .doGet(this._configService.getApiWebFeederRest(),
          'services/negotiation/' + module + '/' + account + '/FINAN/' + dateStartTemp + '/' + dateEndTemp)
        .pipe(map(response => {
          if (response) {
            return response;
          }
          return [];
        }));
    }
  }

  getAfcSearchQuestions() {
    throw new Error('Method not implemented.');
  }

  postAfcSearchQuestions(questionResp: string, questionType: string) {
    throw new Error('Method not implemented.');
  }

  getStrategies() {
    const configWhitelabel = this._configService.getConfigWhitelabel();
    if (configWhitelabel && configWhitelabel.billet.getStrategiesService) {
      if (this._strategiesList.length === 0 || !this._strategiesList) {
        return this._httpService
          .doGet(this._configService.getApiWebFeederRest(), 'services/negotiation/strategies')
          .pipe(map(response => {
            if (response && response.strategies && Array.isArray(response.strategies)) {
              this._strategiesList = response.strategies;
              return this._strategiesList;
            }
            return [];
          }));
      } else {
        return of(this._strategiesList);
      }
    } else {
      return of([]);
    }
  }

  portfolioHistory(account: string, eventDate: string) {
    const initialDateTemp = eventDate ? this._datePipe.transform(eventDate, 'ddMMyyyy') : null;
    const body = {};
    return this._httpService
      .doPost(this._configService.getApiWebFeederRest(),
        'services/negotiation/portfolioHistory?account=' + account + '&portfolioType=' + '5' + '&eventDate=' + initialDateTemp,
        body, false)
      .pipe(map(response => {
        if (response && response.listBeans) {
          return response.listBeans;
        }
        return [];
      }));
  }

  getEarnings(account: string, initialDate: Date, endDate: Date, filterType: number) {
    let path;
    const accountTemp: any = this._configService.getBrokerAccountList();
    const cpfCnpj = accountTemp && accountTemp.cpfCnpj ? accountTemp.cpfCnpj : accountTemp.find(x => x.account === account).cpfCnpj;
    const initialDateTemp = initialDate ? this._datePipe.transform(initialDate, 'ddMMyyyy') : null;
    const endDateTemp = endDate ? this._datePipe.transform(initialDate, 'ddMMyyyy') : null;
    if (filterType === CustodyEarningsFilterType.PROVISIONED) {
      path = '?account=' + account + '&cpfCnpj=' + cpfCnpj + '&initialDate=' + initialDateTemp + '&filterType=' + filterType;
    } else {
      path = '?account=' + account + '&cpfCnpj=' + cpfCnpj + '&initialDate=' + initialDateTemp + '&endDate=' + endDateTemp + '&filterType=' + filterType;
    }
    return this._httpService
      .doGet(this._configService.getApiWebFeederRest(),
        'services/negotiation/earnings' + path)
      .pipe(map(response => {
        if (response && response.listBeans) {
          return response.listBeans;
        }
        return [];
      }));
  }

  geBalancetExternalInfo(getLimite: boolean) {
    const body = {
      request_key: getLimite ? 'getLimite' : 'getSaldo',
      app_name: Constants.DEFAULT_APP_NAME_ADAPTER
    };
    return this._httpService
      .doPostWso2(this._configService.getAdapterOnlyBase(), 'adapter/external/info', body, false, null, false, true)
      .pipe(map(response => {
        if (response && response.data) {
          return response;
        }
        return [];
      }));
  }

  customLiquidationClient(symbol: string, market: MarketEnum) {
    if (!symbol || !market) {
      return of([]);
    }
    const path = '?account=' + this._configService.getBrokerAccountSelected()
      + '&symbol=' + symbol
      + '&marketId=' + (market === MarketEnum.BOVESPA ? Constants.MARKET_BOVESPA : Constants.MARKET_BMF)
      + '&customLiquidationRequestType=' + LiquidationTypeEnum.DAILY
      + '&closeOrInvertPosition=' + CloseInvertEnum.CLOSE
      + '&blockOpenedOrders=true&applicationName=' + Constants.DEFAULT_APP_NAME;
    return this._httpService
      .doPostWso2(this._configService.getApiWebFeederRest(), 'services/negotiation/customLiquidationClient' + path, {}, null, false, true)
      .pipe(map(response => {
        return response ? response : [];
      }));
  }

}
